import {gsap} from "gsap";

const animation = gsap.timeline({paused: true})
    .addLabel('start')
    .from('#section-4 .sec-common__title', {opacity: 0, duration: .8}, 'start+=0.1')
    .from('#section-4 .sec-common__subtitle', {opacity: 0, duration: .8}, 'start+=0.1')
    .from('#section-4 .sec-common__period', {opacity: 0, duration: .8}, 'start+=0.1')
    .from('#section-4 .sec-4__list', {opacity: 0, y: 20,  duration: .6}, 'start+=0.4')
    .from('#section-4 .sec-4__btn', {opacity: 0, y: 20, duration: .6}, 'start+=0.4');

export default {
    id: '#section-4',
    name: '진템명템 의뢰',
    enterEnd() {
        animation.play();
    },
    leaveEnd() {
        animation.seek(0).pause();
    }
};



// WEBPACK FOOTER //
// ./src/js/section-4.js